// extracted by mini-css-extract-plugin
export default {"block-container":"styles_block-container__ONWfR","select-container":"styles_select-container__iMa1B","label":"styles_label__bi5-N","select":"styles_select__WkXhV"};